export type RunFlags = {
  acceptedHelp: boolean;
  helpersJoined: number;
  deaths: number;
};

export class RunState {
  spares: number;
  invuln = 0;
  alive = true;
  cleared = false;
  elapsed = 0;
  flags: RunFlags = {
    acceptedHelp: false,
    helpersJoined: 0,
    deaths: 0,
  };

  constructor(spares = 3) {
    this.spares = spares;
  }

  hit(): "hurt" | "dead" {
    if (this.invuln > 0 || !this.alive) return "hurt";
    this.spares -= 1;
    this.flags.deaths += 1;
    if (this.spares < 0) {
      this.alive = false;
      return "dead";
    }
    this.invuln = 1.25;
    return "hurt";
  }

  tickInvuln(dt: number): void {
    if (this.invuln > 0) this.invuln = Math.max(0, this.invuln - dt);
  }

  markClear(): void {
    this.cleared = true;
    this.alive = false;
  }
}
